"use client";

import * as React from "react";

declare global {
  interface Window {
    /** Injected by the Cookiebot CMP (loaded `beforeInteractive` in the root
     *  layout). `renew()` reopens the consent dialog so visitors can change
     *  their choice. */
    Cookiebot?: { renew: () => void };
  }
}

/**
 * "Cookie-Einstellungen" trigger in the footer. Rendered as a real <button>
 * (it performs an action, not navigation) styled to match the surrounding
 * text links. Reopens the Cookiebot consent dialog via `Cookiebot.renew()`;
 * no-ops gracefully until Cookiebot has initialised.
 */
export function CookieSettingsLink({
  label,
  className = "",
}: {
  label: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={() => window.Cookiebot?.renew()}
      className={`cursor-pointer border-0 bg-transparent p-0 [font:inherit] ${className}`}
    >
      {label}
    </button>
  );
}
